import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';

import Select from 'components/atomic/controls/Select';

const SelectField = ({ name, control, rules = {}, feedback, disabled, ...restProps }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        // eslint-disable-next-line no-unused-vars
        field: { ref, ...restField },
        fieldState: { error },
        formState: { isSubmitted },
      }) => (
        <Select
          {...restProps}
          {...restField}
          valid={isSubmitted && !error}
          invalid={isSubmitted && error}
          feedback={error?.message || feedback}
          disabled={disabled}
        />
      )}
    />
  );
};

SelectField.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  feedback: PropTypes.node,
  disabled: PropTypes.bool,
};

export default SelectField;
